"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageBase = void 0;
class StorageBase {
    constructor(parent, path) {
        this.root = parent.child(path);
    }
}
exports.StorageBase = StorageBase;
